import { Box, Stack, Theme, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { AquariusCard } from "@smartrr/shared/customerPortal/components/AquariusCard";
import { IInstaAllPostData } from "@smartrr/shared/entities/Instagram";
import { IOrgInstaUserData } from "@smartrr/shared/entities/Organization";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { InstagramFill } from "akar-icons";
import React from "react";

import { SeeMoreCard, SinglePostCard } from "./SocialCards";

const MAX_DISPLAYED_POSTS = 12; // max number of posts to display in carousel
interface Props {
  postData: IInstaAllPostData;
  userData: IOrgInstaUserData;
  theme: Theme;
}

export const Instagram = ({ postData, userData, theme }: Props): JSX.Element => {
  const { mediaCount, username } = userData;
  const showSectionTitles = theme.modernThemeSettings?.showHide.showSectionTitles;
  return (
    <Box className={prefixClassName("social-section-wrapper")}>
      <span className="anchor" id="social" />
      {showSectionTitles ? <Typography variant="h2">{typedLocalize("social.title")}</Typography> : null}
      <AquariusCard sx={{ padding: "20px 0 0 0 !important" }}>
        <Stack
          className={prefixClassName("social-header")}
          sx={{
            flexDirection: "row",
            padding: "0 20px 0 20px",
            marginBottom: "15px",
            alignItems: "start",
            justifyContent: "space-between",
          }}
        >
          <Stack direction="column" spacing="3px">
            <Typography variant="h4" sx={{ margin: "0px" }}>
              @{username}
            </Typography>
            <Typography variant="caption1" sx={{ opacity: "80%" }}>
              {typedLocalize("social.postCount", { mediaCount })}
            </Typography>
          </Stack>
          <AquariusButton
            target="_blank"
            href={`https://www.instagram.com/${username}`}
            sx={{ width: "max-content", margin: "0px" }}
          >
            <InstagramFill size="15" color={theme.modernIconsColor} style={{ marginRight: "5px" }} />
            {typedLocalize("social.followBtn")}
          </AquariusButton>
        </Stack>
        <Box
          sx={{
            overflowX: "scroll",
            width: "100%",
            overflowY: "hidden",
          }}
        >
          <Stack
            direction="row"
            spacing={"10px"}
            className={prefixClassName("social-posts-wrapper")}
            sx={{
              width: "max-content",
              padding: "0 20px 20px 20px",
            }}
          >
            {postData.data.slice(0, MAX_DISPLAYED_POSTS).map(post => (
              <SinglePostCard key={post.id} {...post} />
            ))}
            <SeeMoreCard username={username} theme={theme} />
          </Stack>
        </Box>
      </AquariusCard>
    </Box>
  );
};
